import { render, staticRenderFns } from "./ServerStatus.vue?vue&type=template&id=76035ea6"
import script from "./ServerStatus.vue?vue&type=script&lang=js"
export * from "./ServerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports